<nav *ngIf="breadcrumb$ | async as breadcrumb" aria-label="breadcrumb">
  <ol *ngIf="breadcrumb.length" class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/">
        <fa-icon icon="home"></fa-icon>
        {{ "Home" | translate }}
      </a>
    </li>

    <li *ngFor="let item of breadcrumb; let i = index" class="breadcrumb-item">
      <a *ngIf="item?.link" [queryParams]="item?.queryParams" [routerLink]="item?.link">
        {{ item.label | truncate: 50 }}
      </a>

      <a *ngIf="item?.externalLink" [href]="item?.externalLink">
        {{ item.label | truncate: 50 }}
      </a>

      <span *ngIf="!item?.link && !item?.externalLink">
        {{ item.label | truncate: 50 }}
      </span>
    </li>
  </ol>
</nav>
